/**
 * Main Entry Point
 * React application entry point with providers and global styles
 * 
 * NOTE: StrictMode is enabled intentionally for development.
 * It causes components to render twice to help catch bugs with:
 * - Impure rendering
 * - Missing cleanup in effects
 * - Deprecated APIs
 * 
 * This double-rendering ONLY happens in development mode.
 * In production builds, components render once as expected.
 * 
 * If you see duplicate API calls in the console, this is expected
 * behavior and helps ensure your code handles re-renders correctly.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './styles/globals.css';
import './styles/theme.css';

// Create root and render app
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);

// Register Service Worker for PWA installability (production only)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('[PWA] Service Worker registered:', registration.scope);
      })
      .catch((error) => {
        console.error('[PWA] Service Worker registration failed:', error);
      });
  });
}